<template>
    <b-btn variant="link" size="lg" @click.prevent="push">
        <i class="icon-angle-left"></i> Back
    </b-btn>
</template>

<script>
    export default {
        name: 'BtnBack',
        props: {
            pushTo: {
                type: Object
            }
        },
        methods: {
            push() {
                if (this.pushTo) {
                    this.$router.push({...this.pushTo})
                } else {
                    this.$router.go(-1)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .btn {
        font-size: 14px;
        font-weight: bold;
        display: inline-flex;
        align-items: center;
        padding-left: 0;
    }
    .btn-link {
        color: inherit;
        transition: opacity .15s ease-in-out;
        &:hover {
            text-decoration: none;
            opacity: .85;
        };
    }
    i {
        font-size: 23px;
        margin-right: 7px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/BtnBack.vue